// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"367":"419791d3","704":"90f7fe10"}[chunkId] + ".js";
};